import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, SalesRep } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-salesrep-list',
  templateUrl: './epbt-fa-salesrep-list.component.html',
  styleUrls: ['./epbt-fa-salesrep-list.component.scss']
})
export class EpbtFaSalesrepListComponent implements OnInit {

  @Input() salesRep: any;
  @Input() readonly: boolean;


  @Input()
  selectedSalesRepId: SalesRep;

  @Output() selectedSalesRepIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  ngOnInit(): void {
    this.GetSalesRep();
  }

  onSelectionChange(selectedValue: any) {
    this.selectedSalesRepId = selectedValue;
    this.selectedSalesRepIdChange.emit(this.selectedSalesRepId);
  }

  GetSalesRep() {
    this.client.getBisTrackActiveSalesReps().subscribe(res => {
      this.salesRep = res;
      if (this.salesRep.length > 0) {
        this.selectedSalesRepId = this.salesRep[0];
        this.selectedSalesRepIdChange.emit(this.salesRep[0]);
      }
    });
  }

}
